import { render } from "./FireSupportPage.vue?vue&type=template&id=6663a2c8&scoped=true"
import script from "./FireSupportPage.vue?vue&type=script&lang=ts"
export * from "./FireSupportPage.vue?vue&type=script&lang=ts"

import "./FireSupportPage.vue?vue&type=style&index=0&id=6663a2c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6663a2c8"

export default script